import config from 'src/config'
import {
  getGoodsReceiptingInvoiceIdentity,
  getLinkedInvoicesForReceiptingOrder,
} from 'src/utils/reconciliationHealth'
import { getInvoicePreviewUrl } from 'src/utils/invoiceUploadHelpers'

/**
 * Signatures used to treat two invoice URLs as the same attachment
 * (PO invoiceUrl vs library /files/ preview vs ?proxy=1).
 */
export function invoiceAttachmentSignatures(url) {
  const sigs = new Set()
  const raw = String(url || '').trim()
  if (!raw) return sigs
  const add = value => {
    const next = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\/+$/, '')
    if (next) sigs.add(next)
  }
  try {
    const parsed = new URL(raw, 'https://oms.local')
    let path = decodeURIComponent(parsed.pathname || '')
    add(path)
    const parts = path.split('/').filter(Boolean)
    if (parts.length) add(parts[parts.length - 1])
    const filesIdx = path.toLowerCase().lastIndexOf('/files/')
    if (filesIdx >= 0) {
      const key = path.slice(filesIdx + '/files/'.length)
      add(key)
      const keyParts = key.split('/').filter(Boolean)
      if (keyParts.length) add(keyParts[keyParts.length - 1])
    }
  } catch (e) {
    add(raw.split('?')[0].split('#')[0])
  }
  return sigs
}

export function invoiceAttachmentDedupeKey(url) {
  const sigs = [...invoiceAttachmentSignatures(url)]
  return sigs[0] || ''
}

/** Collect unique invoice file URLs from a GR / receipting order row. */
export function collectOrderInvoiceUrls(
  order = {},
  extraUrls = [],
  uploadedInvoices = [],
) {
  const urls = []
  const seen = new Set()
  const push = value => {
    const url = String(value || '').trim()
    if (!url) return
    const sigs = invoiceAttachmentSignatures(url)
    if (![...sigs].length) return
    if ([...sigs].some(sig => seen.has(sig))) return
    sigs.forEach(sig => seen.add(sig))
    urls.push(url)
  }
  for (const url of extraUrls || []) push(url)
  push(order?.invoiceUrl)
  for (const url of order?.attachedInvoicesUrls || []) push(url)
  for (const detail of order?.attachedInvoiceDetails || []) push(detail?.url)

  const expressBase = config?.apiGateway?.EXPRESS_URL || ''
  const identity = getGoodsReceiptingInvoiceIdentity(order, uploadedInvoices)
  push(identity.primaryUrl)
  for (const invoice of getLinkedInvoicesForReceiptingOrder(
    order,
    uploadedInvoices,
  )) {
    push(getInvoicePreviewUrl(invoice, expressBase))
  }
  return urls
}
